import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';

countries.registerLocale(de);

/** ISO 3166-1 alpha-2, z. B. DE, IT, US */
export type CountryCode = string;

export const countryItems: Array<{ text: string; value: CountryCode }> = Object.entries(
  countries.getNames('de', { select: 'official' })
)
  .map(([code, name]) => ({ text: name, value: code.toUpperCase() }))
  .sort((a, b) => a.text.localeCompare(b.text, 'de'));

export const countryLabel = (code?: string | null): string => {
  if (!code) {
    return '';
  }
  const normalized = String(code).trim().toUpperCase();
  if (countries.isValid(normalized)) {
    return countries.getName(normalized, 'de', { select: 'official' }) || normalized;
  }
  // Bereits gespeicherte Freitext-Werte (Migration)
  return String(code).trim();
};

export const isCountryCode = (value: unknown): value is CountryCode =>
  typeof value === 'string' && countries.isValid(value.trim().toUpperCase());

export const normalizeCountryCode = (value: unknown): CountryCode | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  const normalized = value.trim().toUpperCase();
  return countries.isValid(normalized) ? normalized : undefined;
};
